import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  slider: {
    [theme.breakpoints.up('tablet')]: {
      padding: `${SPACES.xxl} ${SPACES.xs}`,
    },
  },
  slideWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: SPACES.m,

    [theme.breakpoints.down('tablet_s')]: {
      flexDirection: 'column',
    },
    [theme.breakpoints.down('tablet')]: {
      marginLeft: 16,
    },
    [theme.breakpoints.up('tablet')]: {
      gap: SPACES.xxl,
      width: '100%',
    },
  },
  sliderWrapper: {
    [theme.breakpoints.down('tablet')]: {
      width: 'calc(100% - 140px)',
    },
    [theme.breakpoints.up('tablet')]: {
      width: '100%',
      maxWidth: '600px',
    },
  },
  slideInput: {
    '&&': {
      [theme.breakpoints.down('tablet_s')]: {
        maxWidth: 120,
        marginBottom: SPACES.xs,
      },
      [theme.breakpoints.up('tablet_s')]: {
        maxWidth: 80,
      },
    },
  },
  container: {
    boxSizing: 'border-box',
    display: 'flex',
    gap: '10px',
    flexDirection: 'column',
    position: 'relative',
    alignContent: 'center',
    border: `1px solid ${theme.palette.custom.grey}`,

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      padding: SPACES.xs,
      gap: '10px',

      borderRadius: 10,
    },

    [theme.breakpoints.up('tablet')]: {
      padding: `${SPACES.xs} ${SPACES.xxl} ${SPACES.xxl}`,
      borderRadius: 15,
    },
  },
  mapWrapper: {
    [theme.breakpoints.down('tablet')]: {
      width: '100%',
    },

    [theme.breakpoints.up('tablet')]: {
      padding: `0px ${SPACES.xxxxxl}`,
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  inputLabel: {
    '&&': {
      [theme.breakpoints.down('laptop')]: {
        fontSize: FONTS.SIZES.s,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.m,
      },
    },
  },
  deleteIcon: {
    '&&': {
      width: '28px',
      height: '28px',
    },
  },
  inputType: {
    '&&': {
      lineHeight: 1.33,

      color: theme.palette.custom.grey2,

      [theme.breakpoints.down('tablet')]: {
        fontSize: FONTS.SIZES.s,
        fontWeight: FONTS.WEIGHTS.light,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.xs,
        fontWeight: FONTS.WEIGHTS.medium,
      },
    },
  },
  addBtn: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    gap: SPACES.xs,
    minWidth: 200,
    alignItems: 'center',

    [theme.breakpoints.down('tablet')]: {
      flexWrap: 'wrap',
      minWidth: 110,
      width: '100%',
      justifyContent: 'center',
    },
  },
}))

export default useStyles
